var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ready)?_c('div',{staticClass:"row-container"},[_c('iframe',{attrs:{"src":_vm.src,"marginheight":"0","marginwidth":"0","frameborder":"0"}})]):_c('v-row',[_c('v-col',{attrs:{"align":"center"}},[_c('v-progress-circular',{attrs:{"size":"84","indeterminate":true}}),_c('h3',{staticClass:"pt-6"},[_vm._v("Loading...")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }